import { AppliedFilters } from '../../../ui/AppliedFilters/AppliedFilters';
import { TextButton } from '../../../ui/Button/Buttons';
import DatePicker from '../../../ui/DatePicker/DatePicker';
import { FilterDropdown } from '../../../ui/FilterDropdown/FilterDropdown';
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux';
import {
  resetDocumentationReqBody,
  setDocumentationReqBody
} from '../../../../store/slices/documentationSlice';
import { sourceOptions, categoryOptions } from './DocumentationFilters.consts';

export function DocumentationFilters() {
  const dispatch = useAppDispatch();
  const { documentationReqBody } = useAppSelector(
    (state) => state.documentation
  );

  const handleChange = (newSelected: string[], filterName: string) => {
    dispatch(
      setDocumentationReqBody({
        ...documentationReqBody,
        [filterName]: newSelected,
        offset: 0
      })
    );
  };

  const handleDateRangeChange = (range: {
    startDate: Date | null;
    endDate: Date | null;
  }) => {
    // if user clear
    if (!range.startDate && !range.endDate) {
      dispatch(
        setDocumentationReqBody({
          ...documentationReqBody,
          createdFrom: '2025-09-01T00:00:00.000Z',
          createdTo: new Date().toISOString()
        })
      );
      return;
    }

    if (!range.startDate || !range.endDate) return;

    const createdFrom = new Date(
      range.startDate.setHours(0, 0, 0, 0)
    ).toISOString();
    const createdTo = new Date(
      range.endDate.setHours(23, 59, 59, 999)
    ).toISOString();

    dispatch(
      setDocumentationReqBody({
        ...documentationReqBody,
        createdFrom,
        createdTo
      })
    );
  };

  return (
    <div className="flex items-center gap-4 w-full">
      <AppliedFilters />
      <FilterDropdown
        onSelectionChange={(newSelected) => handleChange(newSelected, 'source')}
        options={sourceOptions}
        placeholder="Source"
        selectedValues={documentationReqBody.source}
        className="w-full"
      />
      <FilterDropdown
        onSelectionChange={(newSelected) =>
          handleChange(newSelected, 'category')
        }
        options={categoryOptions}
        placeholder="Category"
        selectedValues={documentationReqBody.category}
        className="w-full"
      />
      <DatePicker
        placeholder="Date Created"
        className="w-full"
        initialRange={{
          startDate: documentationReqBody.createdFrom
            ? new Date(documentationReqBody.createdFrom)
            : null,
          endDate: documentationReqBody.createdTo
            ? new Date(documentationReqBody.createdTo)
            : null
        }}
        onDateRangeChange={handleDateRangeChange}
      />
      <TextButton
        onClick={() => {
          dispatch(resetDocumentationReqBody());
        }}
        disabled={
          documentationReqBody.source.length === 0 &&
          documentationReqBody.category.length === 0 &&
          !documentationReqBody.createdFrom &&
          !documentationReqBody.createdTo
        }
        className="w-[94px] text-nowrap text-xs"
      >
        Reset Filters
      </TextButton>
    </div>
  );
}
